import request from '@/utils/request'


// 查询积分任务-任务列列表
export function listPointsTask(query) {
  return request({
    url: '/points/points/task/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询积分任务-任务列分页
export function pagePointsTask(query) {
  return request({
    url: '/points/points/task/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询积分任务-任务列详细
export function getPointsTask(data) {
  return request({
    url: '/points/points/task/detail',
    method: 'get',
    params: data
  })
}

// 新增积分任务-任务列
export function addPointsTask(data) {
  return request({
    url: '/points/points/task/add',
    method: 'post',
    data: data
  })
}

// 修改积分任务-任务列
export function updatePointsTask(data) {
  return request({
    url: '/points/points/task/edit',
    method: 'post',
    data: data
  })
}

// 删除积分任务-任务列
export function delPointsTask(data) {
  return request({
    url: '/points/points/task/delete',
    method: 'post',
    data: data
  })
}
